package org.gymly.api

import io.ktor.client.HttpClient
import io.ktor.client.HttpClientConfig
import io.ktor.client.plugins.HttpTimeout
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.plugins.defaultRequest
import io.ktor.client.request.header
import io.ktor.http.HttpHeaders
import io.ktor.serialization.kotlinx.json.json
import kotlinx.serialization.json.Json

expect fun createGymlyHttpClient(session: PortalSession): HttpClient

/** Cliente Ktor para Coil (sin ContentNegotiation JSON; Accept amplio). */
expect fun createGymlyImageHttpClient(session: PortalSession): HttpClient

fun HttpClientConfig<*>.configureGymly(session: PortalSession) {
    install(HttpTimeout) {
        requestTimeoutMillis = 60_000
        connectTimeoutMillis = 30_000
        socketTimeoutMillis = 60_000
    }
    install(ContentNegotiation) {
        json(
            Json {
                ignoreUnknownKeys = true
                isLenient = true
                explicitNulls = false
                encodeDefaults = true
            },
        )
    }
    defaultRequest {
        header(HttpHeaders.Accept, "application/json")
        session.preferredLocale?.trim()?.takeIf { it.isNotEmpty() }?.let {
            header(HttpHeaders.AcceptLanguage, it)
        }
        session.accessToken?.trim()?.takeIf { it.isNotEmpty() }?.let {
            header(HttpHeaders.Authorization, "Bearer $it")
        }
    }
}

fun HttpClientConfig<*>.configureGymlyImage(session: PortalSession) {
    install(HttpTimeout) {
        requestTimeoutMillis = 60_000
        connectTimeoutMillis = 30_000
        socketTimeoutMillis = 60_000
    }
    defaultRequest {
        header(HttpHeaders.Accept, "*/*")
        session.accessToken?.trim()?.takeIf { it.isNotEmpty() }?.let {
            header(HttpHeaders.Authorization, "Bearer $it")
        }
    }
}

fun resolveApiUrl(session: PortalSession, path: String): String {
    if (path.startsWith("http://") || path.startsWith("https://")) return path
    val base = session.apiBase.trimEnd('/')
    val p = if (path.startsWith("/")) path else "/$path"
    return "$base$p"
}
